import React, {useEffect, useState} from 'react';
import {cloneDeep} from 'lodash';
import classnames from 'classnames';

const AdEditDialog = ({adSetting, position, handleClickCancel, handleClickConfirm}) => {
  const [newAdSetting, setNewAdSetting] = useState(cloneDeep(adSetting));
  const [openPcLayer, setOpenPcLayer] = useState(false);
  const [openMobileLayer, setOpenMobileLayer] = useState(false);

  const getPcType = (position) => {
    let ret;
    if (newAdSetting) {
      if (position === 'sidebar') {
        ret = newAdSetting['sidebar'].activate === 1 ? newAdSetting['sidebar'].type : '선택 안함';
      } else {
        ret = newAdSetting[`pc_${position}`].activate === 1 ? newAdSetting[`pc_${position}`].type : '선택 안함';
      }
    }
    return ret.split('x').join(' x ');
  };

  const getMobileType = (position) => {
    let ret;
    if (newAdSetting) {
      if (position !== 'sidebar') {
        ret = newAdSetting[`mo_${position}`].activate === 1 ? newAdSetting[`mo_${position}`].type : '선택 안함';
      }
    }
    return ret.split('x').join(' x ');
  };
  const getAvailablePcTypeList = (position) => {
    if (adSetting) {
      if (position === 'sidebar') {
        return adSetting['sidebar'].optionList;
      } else {
        return adSetting[`pc_${position}`].optionList;
      }
    } else {
      return []
    }
  };
  const getAvailableMobileTypeList = (position) => {
    if (adSetting) {
      if (position === 'sidebar') {
        return adSetting['sidebar'].optionList;
      } else {
        return adSetting[`mo_${position}`].optionList;
      }
    } else {
      return []
    }
  };

  const handlePcRadioClick = (e) => {
    if (position === 'sidebar') {
      if (e.target.value === 'none') {
        const copied = cloneDeep(newAdSetting);
        copied[position].activate = 0;
        setNewAdSetting(copied);
      } else {
        const copied = cloneDeep(newAdSetting);
        copied['sidebar'].activate = 1;
        copied[position].type = e.target.value;
        setNewAdSetting(copied);
      }
    } else {
      if (e.target.value === 'none') {
        const copied = cloneDeep(newAdSetting);
        copied[`pc_${position}`].activate = 0;
        setNewAdSetting(copied);
      } else {
        const copied = cloneDeep(newAdSetting);
        copied[`pc_${position}`].activate = 1;
        copied[`pc_${position}`].type = e.target.value;
        setNewAdSetting(copied);
      }
    }
    setOpenPcLayer(false);
  };
  const handleMobileRadioClick = (e) => {
    if (e.target.value === 'none') {
      const copied = cloneDeep(newAdSetting);
      copied[`mo_${position}`].activate = 0;
      setNewAdSetting(copied);
    } else {
      const copied = cloneDeep(newAdSetting);
      copied[`mo_${position}`].activate = 1;
      copied[`mo_${position}`].type = e.target.value;
      setNewAdSetting(copied);
    }
    setOpenMobileLayer(false);
  };

  const handleClickOutside = (ev) => {
    if (ev.target === ev.currentTarget) {
      handleClickCancel();
    }
  };
  useEffect(() => {
    document.body.className = "scroll_hide";
    return () => {
      document.body.className = "";
    }
  }, []);

  return (
    <div className="container_layer" onClick={handleClickOutside}>
      <div className="blog_layer" style={{top: 'calc(50% - 128px)'}}>
        <div className="inner_blog_layer inner_blog_layer5">
          <form>
            <div className="cont_layer">
              <strong className="tit_popup">광고 사이즈 변경</strong>
              <div className="wrap_set wrap_set_type1">
                <div className="item_set item_sub">
                  PC
                  <div className={classnames('opt_set', 'opt_category', openPcLayer ? 'opt_open' : '')}>
                    <button type="button" className="btn_opt" onClick={() => setOpenPcLayer(true)}>
                                            <span className="txt_ellip">
                                                {getPcType(position)}
                                            </span>
                      <span className="ico_blog ico_open"/>
                    </button>
                    <div className="layer_opt">
                      <label className={classnames('lab_set', getPcType(position) === '선택 안함' ? 'on' : '')}>
                        <input type="radio" name="category" className="inp_set" value="none"
                               onClick={handlePcRadioClick}
                        />
                        <span className="txt_set txt_ellip">선택 안함</span>
                      </label>
                      {getAvailablePcTypeList(position).map((tp) =>
                        <label className={classnames('lab_set', getPcType(position) === tp ? 'on' : '')} key={tp}>
                          <input type="radio" name="category" className="inp_set" value={tp}
                                 onClick={handlePcRadioClick}
                          />
                          <span className="txt_set txt_ellip">{tp.split('x').join(' x ')}</span>
                        </label>
                      )}
                      <button type="button" className="btn_close" onClick={() => setOpenPcLayer(false)}>
                        <span className="ico_blog"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {position !== 'sidebar' &&
              <div className="wrap_set wrap_set_type1">
                <div className="item_set item_sub">
                  모바일
                  <div className={classnames('opt_set', 'opt_category', openMobileLayer ? 'opt_open' : '')}>
                    <button type="button" className="btn_opt" onClick={() => setOpenMobileLayer(true)}>
                      <span className="txt_ellip">{getMobileType(position)}</span>
                      <span className="ico_blog ico_open"/>
                    </button>
                    <div className="layer_opt">
                      <label className={classnames('lab_set', getMobileType(position) === '선택 안함' ? 'on' : '')}>
                        <input type="radio" name="category" className="inp_set" value="none"
                               onClick={handleMobileRadioClick}
                        />
                        <span className="txt_set txt_ellip">선택 안함</span>
                      </label>
                      {getAvailableMobileTypeList(position).map((tp) =>
                        <label className={classnames('lab_set', getMobileType(position) === tp ? 'on' : '')} key={tp}>
                          <input type="radio" name="category" className="inp_set" value={tp}
                                 onClick={handleMobileRadioClick}
                          />
                          <span className="txt_set txt_ellip">{tp.split('x').join(' x ')}</span>
                        </label>
                      )}
                      <button type="button" className="btn_close" onClick={() => setOpenMobileLayer(false)}>
                        <span className="ico_blog"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
            <div className="fld_btn fld_btn_type1">
              <button type="button" className="btn_cancel" onClick={handleClickCancel}>취소</button>
              <button type="submit" className="btn_default" onClick={(e) => handleClickConfirm(newAdSetting, e)}>확인
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
};

export default AdEditDialog;